import { array } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { identity, values } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { Option } from '@mews-commander/legacy-data-structures';
import { Option as OptionType } from '@mews-commander/types';
import { EnumValue } from '@mews/enumify';
import { getProp } from '@mews/fp';
import { composeProps } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { notNil } from './lodash/helpers';

export const mapBindingToPropSelector = (propSelector: $TSFixMe) => (selectors: $TSFixMe) =>
    selectors.map((selector: $TSFixMe) => composeProps(selector, propSelector));

export const propNotNil = (propName: $TSFixMe) => flow(getProp()(propName), notNil);

/** @deprecated */
export const createOptionsSelector = (
    entitiesSelector: $TSFixMe,
    {
        value = 'id',
        label = 'name',
        secondaryText,
        sortFunction = identity,
        labelLocalizerName,
        inactive,
    }: {
        value?: string;
        label?: string;
        secondaryText?: string;
        sortFunction?: (entities: unknown[]) => unknown[];
        labelLocalizerName?: 'localizeProperty';
        inactive?: string;
    } = {}
) =>
    createSelector(getContainer, entitiesSelector, (container, entities) => {
        const { appLocalizationComponent } = container();
        const localizationFunction = labelLocalizerName ? appLocalizationComponent[labelLocalizerName] : identity;
        const inactiveText = appLocalizationComponent.localizeText(TextKey.Deleted);
        return pipe(
            entities,
            values,
            sortFunction,
            array.map<unknown, OptionType>((e) =>
                Option({
                    value: (e as $TSFixMe)[value],
                    label: localizationFunction((e as $TSFixMe)[label]),
                    // @ts-expect-error
                    secondaryText: (e as $TSFixMe)[inactive] ? inactiveText : (e as $TSFixMe)[secondaryText],
                    // @ts-expect-error
                    inactive: (e as $TSFixMe)[inactive],
                })
            )
        );
    });

/** @deprecated */
export const createEnumOptionsSelector = (
    enumValuesSelector: $TSFixMe,
    { useNameAsValue = false, sortOptions = identity } = {}
) =>
    createSelector(enumValuesSelector, getContainer, (enumValues: EnumValue[], container) => {
        const { appLocalizationComponent } = container();
        const { localizeEnumify } = appLocalizationComponent;
        return pipe(
            enumValues,
            array.map((e) => Option({ value: useNameAsValue ? e.name : e.value, label: localizeEnumify(e) })),
            (options: Array<OptionType>) => sortOptions(options)
        );
    });
